export default "__VITE_ASSET__O_7Wxy5t__"